var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"bg-cal-81B920 hover:bg-cal-green text-white uppercase px-4 py-3 text-sm",attrs:{"type":"submit"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }